export const MESSAGE_QUEUE = {
  TAB_messageQueue_kafkaBrokerDetail_selected: 'TAB_messageQueue_kafkaBrokerDetail_selected',
  TAB_messageQueue_kafkaClusterDetail_selected: 'TAB_messageQueue_kafkaClusterDetail_selected',
  TAB_messageQueue_kafkaTopicDetail_selected: 'TAB_messageQueue_kafkaTopicDetail_selected',

  MESSAGE_QUEUE_KAFKA_DETAIL_DASHBOARD_SETTING_LIST:
    'MESSAGE_QUEUE_KAFKA_DETAIL_DASHBOARD_SETTING_LIST',

  KAFKA_MAP_VIEW: 'KAFKA_MAP_VIEW_messageQueue_kafka',
  KAFKA_MAP_POSITION: 'KAFKA_MAP_POSITION_messageQueue_kafka',
  FILTER_messageQueue_kafka: 'FILTER_messageQueue_kafka',
  GRIDCOLUMNS_messageQueue_kafka_kafkaList: 'GRIDCOLUMNS_messageQueue_kafka_kafkaList',

  GRIDCOLUMNS_messageQueue_kafka_detail_brokerList:
    'GRIDCOLUMNS_messageQueue_kafka_detail_brokerList',
  GRIDCOLUMNS_messageQueue_kafka_detail_topicList:
    'GRIDCOLUMNS_messageQueue_kafka_detail_topicList',
  GRIDCOLUMNS_messageQueue_kafka_detail_consumergroupList:
    'GRIDCOLUMNS_messageQueue_kafka_detail_consumergroupList',
  GRIDCOLUMNS_messageQueue_kafka_detail_topic_infoList:
    'GRIDCOLUMNS_messageQueue_kafka_detail_topic_infoList',
  GRIDCOLUMNS_messageQueue_kafka_detail_topic_messageList:
    'GRIDCOLUMNS_messageQueue_kafka_detail_topic_messageList',
  SELECT_messageQueue_kafka_detail_topic_message: 'SELECT_messageQueue_kafka_detail_topic_message',

  FILTERSEARCH_messageQueue_kafka_kafkaList: 'FILTERSEARCH_messageQueue_kafka_kafkaList',
  FILTERSEARCH_messageQueue_kafka_detail_brokerList:
    'FILTERSEARCH_messageQueue_kafka_detail_brokerList',
  FILTERSEARCH_messageQueue_kafka_detail_topicList:
    'FILTERSEARCH_messageQueue_kafka_detail_topicList',
  FILTERSEARCH_messageQueue_kafka_detail_consumerGroupList:
    'FILTERSEARCH_messageQueue_kafka_detail_consumerGroupList',
  FILTERSEARCH_messageQueue_kafka_detail_topic_messageList:
    'FILTERSEARCH_messageQueue_kafka_detail_topic_messageList',

  METRIC_messageQueue_kafkaView_clusterDetail_metricChart:
    'METRIC_messageQueue_kafkaView_clusterDetail_metricChart',
  METRIC_messageQueue_kafkaView_brokerDetail_metricChart:
    'METRIC_messageQueue_kafkaView_brokerDetail_metricChart',

  METRIC_messageQueue_kafkaView_clusterDetail_metricChart_period:
    'METRIC_messageQueue_kafkaView_clusterDetail_metricChart_period',
  METRIC_messageQueue_kafkaView_brokerDetail_metricChart_period:
    'METRIC_messageQueue_kafkaView_brokerDetail_metricChart_period',
  METRIC_messageQueue_kafkaView_topicDetail_metricChart_period:
    'METRIC_messageQueue_kafkaView_topicDetail_metricChart_period',

  TOGGLE_messageQueue_kafkaClusterDetail_info_expanded:
    'TOGGLE_messageQueue_kafkaClusterDetail_info_expanded',
  TOGGLE_messageQueue_kafkaBrokerDetail_info_expanded:
    'TOGGLE_messageQueue_kafkaBrokerDetail_info_expanded',
  TOGGLE_messageQueue_kafkaTopicDetail_info_expanded:
    'TOGGLE_messageQueue_kafkaTopicDetail_info_expanded',
  TOGGLE_messageQueue_kafkaClusterDetail_userTag_expanded:
    'TOGGLE_messageQueue_kafkaClusterDetail_userTag_expanded',
  TOGGLE_messageQueue_kafkaBrokerDetail_userTag_expanded:
    'TOGGLE_messageQueue_kafkaBrokerDetail_userTag_expanded',
  TOGGLE_messageQueue_kafkaDetail_topicMessageOption_expanded:
    'TOGGLE_messageQueue_kafkaDetail_topicMessageOption_expanded',
};
